import { useQuery } from '@apollo/client';

import { HelpHomeDocument } from './helpHome.gql';

const useHelpHome = () => {
  const { data, error, loading } = useQuery(HelpHomeDocument);

  return {
    error,
    loading,
    phoneSupportLink: data?.viewer.phoneSupportLink?.link,
    standardHotline: data?.viewer.standardHotline,
  };
};

export default useHelpHome;
